import React from "react";
const ConvertContent = (props) => {
    return (React.createElement("div", { className: "convert-options" },
        React.createElement("ul", null, props === null || props === void 0 ? void 0 : props.convertList.map((convert, idx) => {
            if (convert.value !== props.activeState)
                return (React.createElement("li", { onClick: () => {
                        props === null || props === void 0 ? void 0 : props.setActiveState(convert.value);
                        props.closePopup(true);
                    }, key: idx, className: "convert-li d-flex justify-content-between align-items-center hand_cursor" },
                    React.createElement("span", null, convert.display),
                    React.createElement("i", { className: "edel-icon-arrow-right1" })));
        }))));
};
export default ConvertContent;
